/*
*@Author: dcl
*@Description: 合作保险机构信息披露
*@Date: 2022-11-14 11:27:12
*/
<template>
<div class="ibr">
    <el-table class="eltable" :data="companyList" height="13.5rem" :header-cell-style="headerstyle" :cell-style="cellStyle" style="width: 95%">
        <el-table-column prop="name" label="合作保险公司名称" min-width="130" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.name }}</div>
                <!-- <div @click="changehb" class="table-a">
                    {{ scope.row.a && scope.row.a }}
                </div> -->
            </template>
        </el-table-column>
        <el-table-column prop="scope" label="业务合作范围" align="center" min-width="80"></el-table-column>
        <el-table-column prop="time" label="合作起止时间" min-width="120" align="center"></el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [{
                id: 1,
                name: "中国人寿财产保险股份有限公司保定市中心支公司",
                scope: "车险",
                time: "2022年7月1日-2023年6月30日"
            }, {
                id: 2,
                name: "中国大地财产保险股份有限公司沧州中心支公司",
                scope: "车险",
                time: "2022年5月2日-2025年5月1日"
            }, {
                id: 3,
                name: "中国平安财产保险股份有限公司沧州中心支公司",
                scope: "车险",
                time: "2022年3月29日-2025年3月29日"
            }, {
                id: 4,
                name: "中国太平洋财产保险股份有限公司沧州中心支公司",
                scope: "车险",
                time: "2022年5月23日-2023年5月23日"
            }, {
                id: 5,
                name: "阳光财产保险股份有限公司沧州中心支公司",
                scope: "车险",
                time: "2022年4月1日-2025年3月31日"
            }, {
                id: 6,
                name: "中国人民财产保险股份有限公司沧州市分公司",
                scope: "车险",
                time: "2022年3月29日-2023年3月28日"
            }, {
                id: 7,
                name: "中国人民财产保险股份有限公司承德分公司",
                scope: "车险",
                time: "2022年3月28日-2025年3月28日"
            }, {
                id: 8,
                name: "中国大地财产保险股份有限公司邯郸中心支公司",
                scope: "车险",
                time: "2022年3月28日-2025年3月27日"
            }, {
                id: 9,
                name: "中国平安财产保险股份有限公司邯郸中心支公司",
                scope: "车险",
                time: "2022年3月29日-2025年3月28日"
            }, {
                id: 10,
                name: "中国太平洋财产保险股份有限公司邯郸中心支公司",
                scope: "车险",
                time: "2022年3月29日-2025年3月28日"
            }, {
                id: 11,
                name: "天安财产保险股份有限公司邯郸中心支公司",
                scope: "车险",
                time: "2022年11月7日-2023年11月6日"
            }, {
                id: 12,
                name: "中国人民财产保险股份有限公司邯郸中心支公司",
                scope: "车险",
                time: "2022年3月29日-2025年3月28日"
            }, {
                id: 13,
                name: "中国平安财产保险股份有限公司衡水中心支公司",
                scope: "车险",
                time: "2022年9月9日-2025年9月8日"
            }, {
                id: 14,
                name: "中国平安财产保险股份有限公司秦皇岛中心支公司",
                scope: "车险",
                time: "2022年9月16日-2025年9月15日"
            }, {
                id: 15,
                name: "中国大地财产保险股份有限公司石家庄中心支公司",
                scope: "车险",
                time: "2022年4月14日-2025年4月13日"
            }, {
                id: 16,
                name: "中国平安财产保险股份有限公司石家庄中心支公司",
                scope: "车险",
                time: "2022年3月28日-2025年3月27日"
            }, {
                id: 17,
                name: "中国太平洋财产保险股份有限公司石家庄中心支公司",
                scope: "车险",
                time: "2022年4月14日-2025年4月13日"
            }, {
                id: 18,
                name: "中国人民财产保险股份有限公司石家庄中心支公司",
                scope: "车险",
                time: "2022年3月29日-2025年1月15日"
            }, {
                id: 19,
                name: "中国人民财产保险股份有限公司邢台市分公司",
                scope: "车险",
                time: "2022年3月29日-2025年3月28日"
            }, {
                id: 20,
                name: "中国平安财产保险股份有限公司张家口中心支公司",
                scope: "车险",
                time: "2022年9月9日-2025年9月9日"
            }]
        };
    },
    methods: {
        headerstyle() {
            return "font-size: 0.67rem;font-weight: normal;background-color:#FAFAFA;color: #666666;";
        },
        cellStyle() {
            return "font-size: 0.53rem;color: #666666;";
        }
        // changehb() {
        //     window.open('http:localhost:8080/#/informationhb', '_blank')
        // }
    }
};
</script>

<style lang="less" scoped>
.ibr {
    margin-top: .73rem;

    // .table-a {
    //     text-decoration: underline;
    //     color: #FF9600;
    //     cursor: pointer;
    // }
}
</style>



// WEBPACK FOOTER //
// src/view/Informationhb/branch.vue